/**
 * Complete Checklist Item API
 * Feature: 019-build-a-framework
 */

import axiosInstance from '../axiosInstance';

export interface CompleteChecklistItemRequest {
  enrollmentId: number;
  completedByUserId: number;
}

export interface CompleteChecklistItemResponse {
  itemIndex: number;
  completed: boolean;
  completedAt: string;
  completedByUserId: number;
  completedByName: string;
  checklistProgress: {
    completedCount: number;
    totalCount: number;
    percentage: number;
    allComplete: boolean;
  };
}

export const completeChecklistItem = async (
  pathItemId: number,
  itemIndex: number,
  request: CompleteChecklistItemRequest
): Promise<CompleteChecklistItemResponse> => {
  const response = await axiosInstance.post<CompleteChecklistItemResponse>(
    `/api/path-items/${pathItemId}/checklist-items/${itemIndex}/complete`,
    request
  );

  return response.data;
};
